import { z } from "zod";
import { Industry, CompanySize, LeadSource, CompanyStatus } from "../api/crmApi";

export const companySchema = z.object({
    name: z.string().min(1, "Company name is required").max(200, "Company name is too long"),
    website: z
        .string()
        .min(1, "Website is required")
        .url("Please enter a valid URL (e.g. https://example.com)"),
    industry: z.nativeEnum(Industry, { errorMap: () => ({ message: "Industry is required" }) }),
    companySize: z.nativeEnum(CompanySize).optional(),
    status: z.nativeEnum(CompanyStatus).optional(),
    email: z.string().min(1, "Email is required").email("Valid email address required"),
    phone: z.string().min(1, "Phone is required").max(30, "Phone must be 30 characters or less"),
    address: z.string().min(1, "Street address is required"),
    city: z.string().min(1, "City is required"),
    state: z.string().min(1, "State is required"),
    postalCode: z.string().min(1, "Postal code is required").max(20, "Postal code is too long"),
    country: z.string().min(1, "Country is required"),
    leadSource: z.nativeEnum(LeadSource, {
        errorMap: () => ({ message: "Lead source is required" }),
    }),
    numberOfEmployees: z.number().int().positive().optional(),
    annualRevenue: z.number().int().min(0).optional(),
    linkedinUrl: z.string().url("Please enter a valid URL").optional().or(z.literal("")),
    timezone: z.string().optional(),
    description: z.string().optional(),
});

export type CompanyFormValues = z.infer<typeof companySchema>;
